import { EDU_EMAIL_REG } from '@/constants/reg_rules';
import StudentInputItem from '../student-discount/StudentSignupForm/StudentInputItem';
import useTranslation from 'next-translate/useTranslation';
import useForm from 'rc-form-hooks';
import { useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import Button from '@/components/common/Button';
import StudentCodeVerify from '@/components/homepage/components/PopupCreateAccount/StdCodeVerify';
import { sendStdEmailVerifyWithParams } from '@/api/customer';
import { Toast } from '@/components/common/CommonToast';

const StudentVerificationForm = props => {
  const { formStyle, clickTrack, className, onSuccess, reqParams = {} } = props;
  const { t, lang } = useTranslation('common');
  const { getFieldDecorator, values, errors } = useForm();
  const { email } = values;
  const codeRef = useRef<any>(null);

  const [errorRes, setErrorRes] = useState<string>('');
  const [emailError, setEmailError] = useState('');
  const submitButtonDisabled = !email || Object.keys(errors)?.length > 0;

  const handleBlur = () => {
    if (!!document.querySelector('#terms')) (document.querySelector('#terms') as HTMLElement).style.display = `block`;
  };
  const handleFocus = () => {
    if (!!document.querySelector('#terms')) (document.querySelector('#terms') as HTMLElement).style.display = `none`;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (submitButtonDisabled) {
      if (errors?.email?.find(i => i?.field === 'email')?.message || !email) {
        setEmailError(t('ftu:enter_edu_email'));
      }
      return;
    }
    setErrorRes('');
    if (!!clickTrack) clickTrack();
    const res = await sendStdEmailVerifyWithParams({ email, ...reqParams });
    if (res?.result) {
      !!res?.object?.message &&
        Toast({
          text: res?.object?.message,
          duration: 3000,
          position: 'bottom',
          showIcon: false
        });
      codeRef.current?.show();
      return;
    }
    setErrorRes(res?.message);
  };

  return (
    <form onSubmit={handleSubmit} noValidate className={twMerge('flex flex-col gap-3', className)}>
      <div>
        {getFieldDecorator('email', {
          rules: [
            {
              required: true,
              message: t('std_email_error_msg'),
              pattern: new RegExp(EDU_EMAIL_REG)
            }
          ],
          initialValue: ''
        })(
          <StudentInputItem
            id="emailInputId"
            value={email || ''}
            onChange={val => {
              setErrorRes('');
            }}
            onFocus={() => {
              handleFocus();
              setEmailError('');
            }}
            onBlur={handleBlur}
            hasError={!!emailError}
            outerClass={'rounded-full'}
            formStyle={formStyle}
            placeholder={t('ftu:enter_edu_email')}
            label={t('ftu:enter_edu_email')}
            type="email"
          />
        )}
        {!!emailError && (
          <div className="text-left enki-body-3xs-medium text-input-200-fg-critical pt-2">{emailError}</div>
        )}
      </div>
      <div>
        <div className="mb-2 text-left enki-body-3xs-medium text-input-200-fg-critical">{errorRes}</div>
        <Button
          type="primary"
          htmltype="submit"
          className={twMerge('h-12 !text-lg', formStyle === 'light' && 'bg-btn-secondary-bg text-white')}>
          {t('student:student_verify')}
        </Button>
      </div>
      <StudentCodeVerify
        ref={codeRef}
        email={email}
        entry="student-benefits"
        sendEmailParams={{ ...reqParams, email }}
        onSuccess={successRes => {
          onSuccess?.(successRes?.object);
          codeRef.current?.hide();
        }}
      />
    </form>
  );
};

export default StudentVerificationForm;
